module.exports = __webpack_public_path__ + "static/media/black-hotel-icon.1c5356bf.webp";